(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports={
    "$schema": "https://schemas.wp.org/trunk/block.json",
    "apiVersion": 3,
    "name": "cnc83/off-canvas",
    "title": "Off-canvas",
    "category": "layout-cnc83",
    "icon": "",
    "description": "Off-canvas sidebar that slides in and out of the page.",
    "keywords": ["off-canvas", "sidebar", "section"],
    "version": "1.0.0",
    "textdomain": "cnc83",
    "selectors": {
        "root": ".uk-offcanvas"
    },
    "supports": {
        "align": false,
        "html": true,
        "inserter": true,
        "multiple": true,
        "className": true,
        "anchor": true,
        "customClassName": true,
        "spacing": {}
    },
    "attributes": {
        "anchor": {
            "type": "string",
            "default": "my-offcanvas"
        },
        "visible": {
            "type": "boolean",
            "default": true
        },
        "escClose": {
            "type": "boolean",
            "default": false
        },
        "bgClose": {
            "type": "boolean",
            "default": false
        },
        "flip": {
            "type": "boolean",
            "default": false
        },
        "overlay": {
            "type": "boolean",
            "default": false
        },
        "mode": {
            "type": "string",
            "default": "slide"
        }
    },
    "styles": [
        {"name": "default", "label": "Default", "isDefault": true},
        {"name": "muted", "label": "Muted", "isDefault": false},
        {"name": "primary", "label": "Primary", "isDefault": false},
        {"name": "secondary", "label": "Secondary", "isDefault": false}
    ],
    "example": {
        "attributes": {
            "visible": true,
            "overlay": true
        }
    },
    "script": ["./index.min.js", "cnc83-off-canvas-script"],
    "style": ["./index.min.css", "cnc83-off-canvas-style"]
}

},{}],2:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _sidebarControls = _interopRequireDefault(require("./_sidebarControls"));
/**
 * Editor script
 * @package concept83
 * @since 1.0
 */

function Editor(props) {
  var _wp$blockEditor = wp.blockEditor,
    useBlockProps = _wp$blockEditor.useBlockProps,
    InnerBlocks = _wp$blockEditor.InnerBlocks;
  var _props$attributes = props.attributes,
    visible = _props$attributes.visible,
    escClose = _props$attributes.escClose,
    bgClose = _props$attributes.bgClose,
    flip = _props$attributes.flip,
    overlay = _props$attributes.overlay,
    mode = _props$attributes.mode;
  var canvasBarClass = mode !== 'none' && mode !== 'reveal' ? "uk-offcanvas-bar uk-offcanvas-bar-animation uk-offcanvas-".concat(mode) : 'uk-offcanvas-bar';
  var blockProps = useBlockProps({
    className: (0, _classnames.default)({
      'uk-offcanvas uk-open': visible
    }, {
      'uk-offcanvas-overlay': overlay
    }, {
      'uk-offcanvas-flip': flip
    }),
    style: {
      display: visible ? 'block' : 'none'
    },
    'uk-offcanvas': "mode: ".concat(mode, "; flip: ").concat(flip ? 'true' : 'false', "; overlay: ").concat(overlay ? 'true' : 'false', "; esc-close: ").concat(escClose ? 'true' : 'false', "; bg-close: ").concat(bgClose ? 'true' : 'false', ";")
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_sidebarControls.default, {
    props: props
  }), /*#__PURE__*/React.createElement("div", blockProps, /*#__PURE__*/React.createElement("div", {
    className: canvasBarClass
  }, /*#__PURE__*/React.createElement("button", {
    className: "uk-offcanvas-close",
    type: "button",
    "data-uk-close": true
  }), /*#__PURE__*/React.createElement(InnerBlocks, null))));
}
var _default = exports.default = Editor;

},{"./_sidebarControls":4,"@babel/runtime/helpers/interopRequireDefault":6,"classnames":7}],3:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
/**
 * Save script
 * @package concept83
 * @since 1.0
 */

function Save(props) {
  var _wp$blockEditor = wp.blockEditor,
    useBlockProps = _wp$blockEditor.useBlockProps,
    InnerBlocks = _wp$blockEditor.InnerBlocks;
  var _props$attributes = props.attributes,
    visible = _props$attributes.visible,
    escClose = _props$attributes.escClose,
    bgClose = _props$attributes.bgClose,
    flip = _props$attributes.flip,
    overlay = _props$attributes.overlay,
    mode = _props$attributes.mode;
  var canvasBarClass = mode !== 'none' && mode !== 'reveal' ? "uk-offcanvas-bar uk-offcanvas-bar-animation uk-offcanvas-".concat(mode) : 'uk-offcanvas-bar';
  var blockProps = useBlockProps.save({
    className: (0, _classnames.default)({
      'uk-offcanvas uk-open': visible
    }, {
      'uk-offcanvas-overlay': overlay
    }, {
      'uk-offcanvas-flip': flip
    }),
    style: {
      display: visible ? 'block' : 'none'
    },
    'uk-offcanvas': "mode: ".concat(mode, "; flip: ").concat(flip ? 'true' : 'false', "; overlay: ").concat(overlay ? 'true' : 'false', "; esc-close: ").concat(escClose ? 'true' : 'false', "; bg-close: ").concat(bgClose ? 'true' : 'false', ";")
  });
  return /*#__PURE__*/React.createElement("div", blockProps, /*#__PURE__*/React.createElement("div", {
    className: canvasBarClass
  }, /*#__PURE__*/React.createElement("button", {
    className: "uk-offcanvas-close",
    type: "button",
    "data-uk-close": true
  }), /*#__PURE__*/React.createElement(InnerBlocks.Content, null)));
}
var _default = exports.default = Save;

},{"@babel/runtime/helpers/interopRequireDefault":6,"classnames":7}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Block sidebar controls script
 * @package concept83
 * @since 1.0
 */
function SidebarControls(_ref) {
  var props = _ref.props;
  var _props$attributes = props.attributes,
    visible = _props$attributes.visible,
    escClose = _props$attributes.escClose,
    bgClose = _props$attributes.bgClose,
    flip = _props$attributes.flip,
    overlay = _props$attributes.overlay,
    mode = _props$attributes.mode,
    setAttributes = props.setAttributes;
  var _wp$components = wp.components,
    PanelBody = _wp$components.PanelBody,
    ToggleControl = _wp$components.ToggleControl,
    BaseControl = _wp$components.BaseControl,
    Button = _wp$components.Button,
    ButtonGroup = _wp$components.ButtonGroup;
  var InspectorControls = wp.blockEditor.InspectorControls;
  function onModalToggleChange(value) {
    setAttributes({
      visible: value
    });
  }
  function onEscCloseChange(value) {
    setAttributes({
      escClose: value
    });
  }
  function onBgCloseChange(value) {
    setAttributes({
      bgClose: value
    });
  }
  function onFlipChange(value) {
    setAttributes({
      flip: value
    });
  }
  function onOverlayChange(value) {
    setAttributes({
      overlay: value
    });
  }
  function onModeChange(value) {
    setAttributes({
      mode: value
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InspectorControls, {
    group: "settings"
  }, /*#__PURE__*/React.createElement(PanelBody, {
    title: "General",
    initialOpen: true
  }, /*#__PURE__*/React.createElement(ToggleControl, {
    label: "Toggle modal",
    help: "Show/hide modal box.",
    checked: visible,
    disabled: false,
    onChange: function onChange(value) {
      return onModalToggleChange(value);
    }
  })), visible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PanelBody, {
    title: "Settings",
    initialOpen: false
  }, /*#__PURE__*/React.createElement(ToggleControl, {
    label: "Close on escape",
    help: "Close the modal when the 'Esc' key is pressed.",
    checked: escClose,
    disabled: false,
    onChange: function onChange(value) {
      return onEscCloseChange(value);
    }
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(ToggleControl, {
    label: "Background close",
    help: "Close the modal when the background is clicked.",
    checked: bgClose,
    disabled: false,
    onChange: function onChange(value) {
      return onBgCloseChange(value);
    }
  }), /*#__PURE__*/React.createElement(ToggleControl, {
    label: "Flip",
    help: "Slides off-canvas in from the right.",
    checked: flip,
    disabled: false,
    onChange: function onChange(value) {
      return onFlipChange(value);
    }
  }), /*#__PURE__*/React.createElement(ToggleControl, {
    label: "Overlay",
    help: "Adds an overlay layer outside the canvas.",
    checked: overlay,
    disabled: false,
    onChange: function onChange(value) {
      return onOverlayChange(value);
    }
  }), /*#__PURE__*/React.createElement(BaseControl, null, /*#__PURE__*/React.createElement("label", {
    className: "cnc83__component-label"
  }, "Mode"), /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return onModeChange('none');
    },
    disabled: false,
    text: "None",
    isPressed: mode == 'none'
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return onModeChange('slide');
    },
    disabled: false,
    text: "Slide",
    isPressed: mode == 'slide'
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return onModeChange('push');
    },
    disabled: false,
    text: "Push",
    isPressed: mode == 'push'
  })))))));
}
var _default = exports.default = SidebarControls;

},{}],5:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _block = _interopRequireDefault(require("../block.json"));
var _editor = _interopRequireDefault(require("./_editor"));
var _save = _interopRequireDefault(require("./_save"));
/**
 * Block registration
 * @package concept83
 * @since 1.0
 */

var registerBlockType = wp.blocks.registerBlockType;
registerBlockType(_block.default.name, {
  title: _block.default.title,
  icon: /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.9,2.05h2v2h-2v-2Zm5,0v2h2v-2h-2Zm0,15.3h2v-1.77h-2v1.77Zm0-8.87h2v-1.77h-2v1.77Zm0,4.43h2v-1.77h-2v1.77Zm0,9.09h2v-2h-2v2Zm-5,0h2v-2h-2v2ZM10.9,2.05H2v2h9v15.96H2v2h11V2.05h-2.1Zm-5.28,8.74l1.29-1.29,1.29,1.29,1.41-1.41-1.29-1.29,1.29-1.29-1.41-1.41-1.29,1.29-1.29-1.29-1.41,1.41,1.29,1.29-1.29,1.29,1.41,1.41Z",
    strokeWidth: "0"
  })),
  edit: _editor.default,
  save: _save.default
});

},{"../block.json":1,"./_editor":2,"./_save":3,"@babel/runtime/helpers/interopRequireDefault":6}],6:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],7:[function(require,module,exports){
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {
		// register as 'classnames', consistent with npm package name
		define('classnames', [], function () {
			return classNames;
		});
	} else {
		window.classNames = classNames;
	}
}());

},{}]},{},[5]);
